import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import styled from 'styled-components'


import { withFirebase } from '../../components/Firebase';

const Styles = styled.div`

  .password-conflict {
    color: red;
  }
`;

const SignUpPage = () => (
    <div>
        <h1>SignUp</h1>
        <SignUpForm />
    </div>
);

const INITIAL_STATE = {
    email: '',
    passwordOne: '',
    passwordTwo: '',
    error: null,
};

class SignUpFormBase extends Component {
    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE };

    }
    onSubmit = event => {
        const { email, passwordOne } = this.state;
        this.props.firebase
            .doCreateUserWithEmailAndPassword(email, passwordOne)
            .then(authUser => {
                this.setState({ ...INITIAL_STATE });
            })
            .catch(error => {
                this.setState({ error });
            });
        event.preventDefault();
    }

    onChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    render() {
        const {
            email,
            passwordOne,
            passwordTwo,
            error,
        } = this.state;

        const isInvalid =
            passwordOne !== passwordTwo ||
            passwordOne === '' ||
            email === ''

        const passwordConflict = (passwordOne !== passwordTwo && passwordTwo !== '')

        return (
            <Styles>
                <Form onSubmit={this.onSubmit}>
                    <Form.Group>
                        <Form.Label>Email address</Form.Label>
                        <Form.Control type="text" name="email" value={email} onChange={this.onChange} placeholder="Enter email" />
                    </Form.Group>
                    <Form.Row>
                        <Col>
                            <Form.Label>Password</Form.Label>
                            <Form.Control type="password" name="passwordOne" value={passwordOne} onChange={this.onChange} placeholder="Enter password" />
                            {passwordConflict && <Form.Text className="password-conflict">
                                Passwords do not match
    </Form.Text>}
                        </Col>
                        <Col>
                            <Form.Label>Confirm password</Form.Label>
                            <Form.Control type="password" name="passwordTwo" value={passwordTwo} onChange={this.onChange} placeholder="Enter password again" />
                        </Col>

                    </Form.Row>

                    <Button disabled={isInvalid} variant="primary" type="submit">
                        Sign Up</Button>
                    {error && <p>{error.message}</p>}
                </Form>
            </Styles>

        );
    }
}

const SignUpLink = () => (
    <p>
        Don't have an account? <Link to={{
            pathname: "/signup"
        }}>Sign Up</Link>
    </p>
);

const SignUpForm = withFirebase(SignUpFormBase);

export default SignUpPage;
export { SignUpForm, SignUpLink };